import config from 'configDir/index';
import { post } from './http';

const uploadFileSingleService = post('/uploadFile/minio/single', config.commonServiceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  uploadFileSingleService,
};
